import * as React from 'react';
import './Document.css';

import Block from './Block'
import Definition from './Definition'

import * as actions from '../actions'
import { NetworkUser } from 'golgi'

import * as Model from '../types/document'
import { Cursor, CursorV } from '../lib/Cursor'
import Scratch from 'src/view/Scratch';

class Document extends React.Component<{
  documentC: Cursor<Model.Document>
}> {

  render() {
    return <NetworkUser debugName="Document" props={this.props} state={this.state} render={() => {
      const { documentC } = this.props

      const definitionsC = documentC.select('definitions')

      return (
        <div className="Document">
          <div className="Document-main">
            {CursorV.elemsKeyed(definitionsC.fetch(), 'id').map((definitionC) =>
              !definitionC.value().hidden && <Definition key={definitionC.value().id} definitionC={definitionC.unfetch()} stack={[{type: 'editor', definitionP: definitionC.path()}]}/>
            )}
            <Block right={
              <button style={{padding: 20}}
                onClick={() => actions.act(() => {
                  definitionsC.update((definitions) =>
                    definitions.concat([actions.makeNewDefinition()])
                  )
                })}>
                Add new function
              </button>
            } />
            <Scratch blockC={documentC._('scratch')} stack={[{type: 'scratch'}]} />
          </div>
        </div>
      )
    }} />
  }
}

export default Document;



// WEBPACK FOOTER //
// ./src/view/Document.tsx